/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';
import { USER_UPDATE_FIELDS } from './users.shared';

export const GET_ACTIVE_USERS_FOR_OWNER = gql`
  query {
    ownerActiveUsers {
      id
      firstName
      lastName
      displayColour
    }
  }
`;

export const GET_OWNER_USERS = gql`
  query {
    ownerUsers {
      id
      firstName
      lastName
      email
      userType
      userRole
      acceptedTosAt
      displayColour
      createdAt
      deletedAt
    }
  }
`;

export const GET_USER_FOR_OWNER = gql`
  query ($id: String!) {
    ownerUser(id: $id) {
      id
      firstName
      lastName
      email
      userType
      userRole
      displayColour
      settings
      createdAt
      deletedAt
      userRelations {
        relationType
        createdAt
      }
    }
  }
`;

export const UPDATE_OWNER_USER = gql`
  ${USER_UPDATE_FIELDS}
  mutation ($ownerId: String!, $id: String!, $firstName: String!, $lastName: String!, $email: String!, $userRole: String!, $displayColour: String) {
    updateOwnerUser(ownerId: $ownerId, input: {
      id: $id,
      firstName: $firstName,
      lastName: $lastName,
      email: $email,
      userRole: $userRole,
      displayColour: $displayColour,
    }) {
      ...UserUpdateFields
    }
  }
`;

export const DELETE_OWNER_USER = gql`
  mutation ($id: String!) {
    deleteOwnerUser(id: $id)
  }
`;

export const UPDATE_OWNER_USER_SETTINGS = gql`
  mutation UpdateOwnerUserSettings($settings: UserSettingsJSON) {
    ownerUpdateUserSettings(input: { settings: $settings }) {
      success
    }
  }
`;
